import {
  GET_HANDOVERLISTENGINEERING,
  GET_HANDOVERLISTENGINEERING_SUCCESS,
  GET_HANDOVERLISTENGINEERING_FAIL,
  DELETE_HANDOVERLISTENGINEERING,
  DELETE_HANDOVERLISTENGINEERING_SUCCESS,
  DELETE_HANDOVERLISTENGINEERING_FAIL,
  UPDATE_HANDOVERLISTENGINEERING,
  UPDATE_HANDOVERLISTENGINEERING_SUCCESS,
  UPDATE_HANDOVERLISTENGINEERING_FAIL,
  ADD_NEW_HANDOVERLISTENGINEERING,
  ADD_HANDOVERLISTENGINEERING_SUCCESS,
  ADD_HANDOVERLISTENGINEERING_FAIL,
  HANDOVERLISTENGINEERING_LOADING,
  HANDOVERLISTENGINEERING_RESET
} from "./actionType";

export const resetHandoverListEngineeringState = (actionType) => ({
  type: HANDOVERLISTENGINEERING_RESET,
  payload: { actionType },
});

export const getHandoverListEngineeringSuccess = (actionType, data) => ({
  type: GET_HANDOVERLISTENGINEERING_SUCCESS,
  payload: { actionType, data },
});

export const getHandoverListEngineeringFail = (actionType, error) => ({
  type: GET_HANDOVERLISTENGINEERING_FAIL,
  payload: { actionType, error },
});

export const getHandoverListEngineering = data => ({
  type: GET_HANDOVERLISTENGINEERING,
  payload: data,
});

export const getHandoverListEngineeringLoading = () => ({
  type: HANDOVERLISTENGINEERING_LOADING
});

export const deleteHandoverListEngineering = data => ({
  type: DELETE_HANDOVERLISTENGINEERING,
  payload: data,
});

export const deleteHandoverListEngineeringSuccess = data => ({
  type: DELETE_HANDOVERLISTENGINEERING_SUCCESS,
  payload: data,
});

export const deleteHandoverListEngineeringFail = error => ({
  type: DELETE_HANDOVERLISTENGINEERING_FAIL,
  payload: error,
});

export const updateHandoverListEngineering = data => ({
  type: UPDATE_HANDOVERLISTENGINEERING,
  payload: data,
});

export const updateHandoverListEngineeringFail = error => ({
  type: UPDATE_HANDOVERLISTENGINEERING_FAIL,
  payload: error,
});

export const updateHandoverListEngineeringSuccess = data => ({
  type: UPDATE_HANDOVERLISTENGINEERING_SUCCESS,
  payload: data,
});

export const addNewHandoverListEngineering = data => ({
  type: ADD_NEW_HANDOVERLISTENGINEERING,
  payload: data,
});

export const addHandoverListEngineeringSuccess = data => ({
  type: ADD_HANDOVERLISTENGINEERING_SUCCESS,
  payload: data,
});

export const addHandoverListEngineeringFail = error => ({
  type: ADD_HANDOVERLISTENGINEERING_FAIL,
  payload: error,
});